export type ClerkSessionResolution = "loading" | "signed_in" | "signed_out";

export function getClerkSessionResolution(
  clerkLoaded: boolean,
  isSignedIn: boolean | undefined,
): ClerkSessionResolution {
  if (!clerkLoaded) return "loading";
  return isSignedIn ? "signed_in" : "signed_out";
}

export function isAuthStateLoading(
  clerkLoaded: boolean,
  userQueryLoading: boolean,
): boolean {
  return !clerkLoaded || userQueryLoading;
}